import { createFileRoute } from "@tanstack/react-router";

import React from "react";
import { ACL } from "src/components/acl";
import { useTranslation } from "react-i18next";
import { Subheading } from "src/components/base/heading";
import SINGLE_GROUP_CONTEXT from "src/context/internal/group";
import ReadOnlyRuleSets from "src/components/rulesets";

/**
 * The properties for {@link GroupOutboundACLs}
 */
export type GroupOutboundACLsProps = {};

/**
 * Outbound ACLs of a group
 */
function GroupOutboundACLs(props: GroupOutboundACLsProps) {
    const [t] = useTranslation("admin-group-view");

    const ctx = React.useContext(SINGLE_GROUP_CONTEXT);

    return (
        <div className={"flex flex-col gap-6"}>
            <Subheading>{t("heading.add-new-acl")}</Subheading>
            <ACL
                key={"new-outbound"}
                onChange={ctx.reset}
                src={{ type: "Group", value: ctx.group }}
                startEditable={true}
            />

            <Subheading>{t("heading.existing-acls")}</Subheading>
            {ctx.group.access_rules.outbound.map((acl) => (
                <ACL key={acl.uuid} src={acl.src} acl={acl} onChange={ctx.reset} />
            ))}

            <Subheading>{t("heading.rulesets")}</Subheading>
            {ctx.group.rulesets.outbound.map((ruleset) => (
                <ReadOnlyRuleSets
                    key={ruleset.uuid}
                    name={ruleset.name}
                    description={ruleset.description}
                    rules={ruleset.rules}
                    sources={ruleset.src_or_dst}
                />
            ))}
        </div>
    );
}

export const Route = createFileRoute("/_admin/a/groups/$groupId/_group/outbound-acls")({
    component: GroupOutboundACLs,
});
